import React, {useState, createContext, ReactChild, useContext, ReactElement} from 'react';

type ModalContextValue = (modalContent: ReactChild | undefined) => void;

export const ModalContext = createContext<ModalContextValue>(() => {
  /* noop */
});

export const useSetModalContent = (): ModalContextValue => useContext(ModalContext);

interface Props {
  children: ReactChild | ReactChild[];
}

function ModalContextProvider({children}: Props): ReactElement {
  const [modal, setModal] = useState<ReactChild | undefined>(undefined);

  return (
    <ModalContext.Provider value={setModal}>
      {children}
      {modal}
    </ModalContext.Provider>
  );
}

export default ModalContextProvider;
